import { EntryComponent, Assessment, QualificationMin } from '@cambridgeassessment/lib-ee-commons';
import { DownloadData, Section } from '../../types/Sections';
import {
  SectionsActionTypes,
  SET_SECTIONS,
  SET_QUALIFICATIONS,
  SET_ASSESSMENTS,
  SET_COMPONENTS,
  SET_FILE_RESULTS,
  SET_ARE_FILES_LOADING,
  SET_FILES_TOTAL,
  SET_FILES_NEXT_PAGE_URL,
  SET_IS_DOWNLOAD_FILES_LOADING,
} from './types';

const setQualifications = (qualifications: QualificationMin[]): SectionsActionTypes => ({
  type: SET_QUALIFICATIONS,
  payload: { qualifications },
});

const setAssessments = (assessments: Assessment[]): SectionsActionTypes => ({
  type: SET_ASSESSMENTS,
  payload: { assessments },
});

const setComponents = (components: EntryComponent[]): SectionsActionTypes => ({
  type: SET_COMPONENTS,
  payload: { components },
});

const setSections = (sections: Section[]): SectionsActionTypes => ({
  type: SET_SECTIONS,
  payload: { sections },
});

const setAreFilesLoading = (isLoading: boolean): SectionsActionTypes => ({
  type: SET_ARE_FILES_LOADING,
  payload: { isLoading },
});

const setFileResults = (fileResults: DownloadData[] | undefined): SectionsActionTypes => ({
  type: SET_FILE_RESULTS,
  payload: { fileResults },
});

const setFilesTotal = (total: number): SectionsActionTypes => ({
  type: SET_FILES_TOTAL,
  payload: { total },
});

const setFilesNextPageUrl = (nextUrl?: string): SectionsActionTypes => ({
  type: SET_FILES_NEXT_PAGE_URL,
  payload: { nextUrl },
});

const setIsDownloadFilesLoading = (isLoading: boolean): SectionsActionTypes => ({
  type: SET_IS_DOWNLOAD_FILES_LOADING,
  payload: { isLoading },
});

export default {
  setQualifications,
  setAssessments,
  setComponents,
  setSections,
  setAreFilesLoading,
  setFileResults,
  setFilesTotal,
  setFilesNextPageUrl,
  setIsDownloadFilesLoading,
};
